import React from "react"
import { Accept } from "react-dropzone"

import { ApiResponse } from "shared/types/ApiResponse"
import { SelectOption } from "shared/types/Select"
import { AttachmentType } from "shared/types/__generated__/graphql"

import { ProjectAttachmentsView } from "./ProjectAttachmentsView"

export interface ProjectAttachmentsModel {
  files: AttachmentType[] | null | undefined
  categories: SelectOption<string>[] | null | undefined
  filesByCategory: Record<string, AttachmentType[] | null | undefined>
  acceptsByCategory: Record<string, Accept>
  isReadonly?: boolean
  isLoading?: boolean
  isError?: boolean
  onUpload?: (
    files: File | File[],
    category: string
  ) => Promise<ApiResponse<unknown>>
  onUploadComplete?: () => Promise<unknown> | void
  onDelete?: (file: AttachmentType) => void
  onReplace?: (file: AttachmentType) => void
}

export const ProjectAttachments = React.memo(
  (props: ProjectAttachmentsModel) => {
    return <ProjectAttachmentsView {...props} />
  }
)
